import "./LoaderButton.scss";

const LoaderButton = () => {
  return <span className="loader"></span>;
};

export default LoaderButton;
